module.exports = __webpack_public_path__ + "img/d2.d7c50901.png";